import React from "react";

function FieldSectionContainer({ children }) {
  return <div style={{ padding: "0px 24px" }}>{children}</div>;
}

export default FieldSectionContainer;
